import * as React from "react";
import "./BudgetSlider.css";
import * as cn from "classnames";
import { campaignBudgetForm, CurrencyMapping } from "@store";

import { Fieldset } from "./Fieldset";
import { Triangle } from "@icons";

function magnetBudget(value: string) {
    const reg = /[7-9][0-9]$/;
    if (value.search(reg) > 0) {
        const newValue: number = Number(value.replace(reg, "00")) + 100;

        return newValue.toString();
    }

    return value;
}

function convertLargeBudget(value: any) {
    if (value > 1000000) {
        return Math.round((value / 1000000) * 100) / 100 + "M";
    }
    if (value > 10000) {
        return Math.round((value / 1000) * 100) / 100 + "k";
    }
    return value;
}

function roundTick(value: any) {
    if (value > 1000000) {
        return (Math.round((value / 1000000) * 100) / 100) * 1000000;
    }
    if (value > 10000) {
        return (Math.round((value / 1000) * 100) / 100) * 1000;
    }
    return value;
}

export interface BudgetSliderComponentProps {
    budgetForm: typeof campaignBudgetForm.types.selectorResult;
    budgetFormEvents: typeof campaignBudgetForm.types.eventBindings;
    currencyMapping: CurrencyMapping[];
}

export interface BudgetSliderComponentState {
    maxBudget: number;
}

// const BUDGET_TICK_COUNT = 5;
const DEFAULT_MAX_BUDGET = 100000;

export class BudgetSliderComponent extends React.Component<BudgetSliderComponentProps, BudgetSliderComponentState> {
    constructor(props: BudgetSliderComponentProps) {
        super(props);
        this.state = {
            maxBudget: DEFAULT_MAX_BUDGET
        };

        this.recountWithRate = this.recountWithRate.bind(this);
        this.countTicks = this.countTicks.bind(this);
    }

    componentDidUpdate(prevProps: BudgetSliderComponentProps) {
        if (prevProps.budgetForm.fields.currency.value !== this.props.budgetForm.fields.currency.value) {
            this.recountWithRate();

            return;
        }

        const currentBudget = this.props.budgetForm.fields.budget.value;
        const prevBudget = prevProps.budgetForm.fields.budget.value;

        if (currentBudget !== prevBudget) {
            this.recountWithRate();

            return;
        }
    }

    recountWithRate() {
        const { budgetForm, currencyMapping } = this.props;

        const selectedCurrency = budgetForm.fields.currency.value;
        const currentBudget = budgetForm.fields.budget.value || 0;
        const rate = selectedCurrency && currencyMapping.find(c => c.isoCode === selectedCurrency).rate;
        const maxBudget = Math.round(Number((DEFAULT_MAX_BUDGET / Number(rate)).toFixed(0)) / 1000) * 1000;

        if (currentBudget <= maxBudget) {
            this.setState({
                ...this.state,
                maxBudget: maxBudget
            });

            return;
        }

        if (currentBudget > maxBudget && currentBudget <= 999999999) {
            this.setState({
                ...this.state,
                maxBudget: currentBudget
            });

            return;
        }

        if (currentBudget > maxBudget && currentBudget > 999999999) {
            this.setState({
                ...this.state,
                maxBudget: 999999999
            });

            return;
        }
    }

    countTicks() {
        const { maxBudget } = this.state;
        const tick = maxBudget / 5;
        return [0, tick, 2 * tick, 3 * tick, 4 * tick, maxBudget];
    }

    render() {
        const { budgetForm, budgetFormEvents, currencyMapping } = this.props;
        const ticks = this.countTicks();

        return (
            <>
                <span className="budget-input-title">Budget</span>
                <div className="budget-input-wrapper tour-campaign-budget">
                    <Fieldset
                        label="Amount"
                        className="campaign-aside-fieldset-select custom-budget-slider-value"
                        isMandatory={true}
                        errorMessage={budgetForm.fields.budget}
                        errorMessageClassName="error-field"
                    >
                        <input
                            name="budget-label"
                            type="text"
                            value={budgetForm.fields.budget.value || 0}
                            {...budgetFormEvents.fields.budget}
                        />
                    </Fieldset>
                    <Fieldset
                        className="campaign-aside-fieldset-select"
                        label="Currency"
                        isMandatory={true}
                        errorMessage={budgetForm.fields.currency}
                        errorMessageClassName="error-field"
                        icon={Triangle}
                        svgClassName="svg-triangle custom-currency-svg-triangle"
                    >
                        <select
                            className="common-select"
                            name="currency"
                            id=""
                            value={budgetForm.fields.currency.value || "default"}
                            {...budgetFormEvents.fields.currency}
                        >
                            {currencyMapping &&
                                currencyMapping.map((currency, index) => (
                                    <option key={index} value={currency.isoCode}>
                                        {currency.isoCode}
                                    </option>
                                ))}
                        </select>
                    </Fieldset>
                </div>
                <input
                    type="range"
                    min="0"
                    max={this.state.maxBudget}
                    step="1"
                    className={cn("slider", budgetForm.fields.budget.visualState)}
                    id="myRange"
                    name="budget"
                    value={budgetForm.fields.budget.value || 0}
                    {...budgetFormEvents.fields.budget}
                    onChange={e => budgetFormEvents.fields.budget.onChange(magnetBudget(e.target.value))}
                />

                <div className="slider-legend">
                    {ticks.map((tick, index, all) => (
                        <span
                            className={cn("slider-degree", "slider-legend__item", {
                                first: index === 0,
                                last: index === all.length - 1
                            })}
                            key={`${index}`}
                        >
                            <span className="slider-degree__tick" />
                            <span
                                className="slider-degree__value"
                                onClick={() => budgetFormEvents.fields.budget.onChange(roundTick(tick))}
                            >{`${convertLargeBudget(tick)}`}</span>
                        </span>
                    ))}
                </div>
            </>
        );
    }
}
